import React from 'react';
import { StyledModal } from './Modal.styles';
import { ApButtonDanger, ApButtonSecondary } from '@alixpartners/ui-components';
export const Modal = ({
	onClose,
	onDelete,
	title,
	cancelText = 'Cancel',
	body,
	suppressFooter,
	maxWidth,
}) => {
	return (
		<StyledModal
			maxWidth={maxWidth}
			header={title}
			footer={
				suppressFooter
					? undefined
					: () => (
							<React.Fragment>
								<ApButtonSecondary onClick={onClose}>
									{cancelText}
								</ApButtonSecondary>
								{onDelete && (
									<ApButtonDanger onClick={onDelete}>Delete</ApButtonDanger>
								)}
							</React.Fragment>
					  )
			}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			{body}
		</StyledModal>
	);
};
